import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionStorage from "redux-persist/lib/storage/session";
import { combineReducers } from "redux";
import authReducer from "../reducer/authprovider";
import rememberMeReducer from "../reducer/rememberme";
import appSettingReducer from "../reducer/appsetting"; // Ensure correct import path

// Auth uses sessionStorage: survives same-tab redirects (e.g. Fiserv payment flow)
// but is not exposed across tabs or browser sessions like localStorage would be.
const authPersistConfig = {
  key: "auth",
  storage: sessionStorage,
};

// Root config persists only rememberMe to localStorage
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["rememberMe"],
};

// Combine reducers
const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  rememberMe: rememberMeReducer,
  appSetting: appSettingReducer, // appSetting will not be persisted
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
});

const persistor = persistStore(store);

export { store, persistor };
